{
 "title": {
  "x": 260,
  "y": 677,
  "w": 430,
  "h": 41,
  "lane": {
   "x": 250,
   "y": 672,
   "w": 450,
   "h": 55
  }
 },
 "body1": {
  "x": 226,
  "y": 802,
  "w": 494,
  "h": 32,
  "lane": {
   "x": 190,
   "y": 794,
   "w": 566,
   "h": 44
  }
 },
 "body2": {
  "x": 201,
  "y": 843,
  "w": 543,
  "h": 32,
  "lane": {
   "x": 190,
   "y": 840,
   "w": 566,
   "h": 44
  }
 },
 "cta": {
  "x": 420,
  "y": 949,
  "w": 100,
  "h": 37,
  "lane": {
   "x": 300,
   "y": 940,
   "w": 340,
   "h": 58
  }
 },
 "link": {
  "x": 379,
  "y": 1048,
  "w": 183,
  "h": 28,
  "lane": {
   "x": 378,
   "y": 1044,
   "w": 185,
   "h": 32
  }
 }
}